export const STORE_CHAT = 'store/chat'
